import { Cloud, Boxes, KeyRound, Globe, MonitorPlay } from 'lucide-react';
import { FlowDiagram, FlowRow, type FlowNode } from '@vnetwork/ui/data';
import type { DrmStream } from '@/api/aes';
import { fmtDuration } from '../shared';

/**
 * Delivery pipeline for an AES-128 DRM stream, drawn with the design-system
 * `FlowDiagram`. Node titles are role-based (Origin / Packager / Key server /
 * CDN / Viewer) — the customer-facing pipeline, not internal service codenames.
 */
export function StreamTopology({ stream }: { stream: DrmStream }) {
  const columns: FlowNode[][] = [
    [{
      id: 'origin', title: 'Origin', icon: <Cloud size={16} />, to: ['packager'], defaultOpen: true,
      children: <FlowRow label="Source" value="CLEAR" />,
    }],
    [{
      id: 'packager', title: 'Packager', icon: <Boxes size={16} />, to: ['keyserver'], defaultOpen: true,
      children: (
        <>
          <FlowRow label="Shard" value={stream.shard ?? 'unassigned'} />
          <FlowRow label="DVR" value={fmtDuration(stream.dvr_seconds)} />
        </>
      ),
    }],
    [{
      id: 'keyserver', title: 'Key server', icon: <KeyRound size={16} />, to: ['cdn'], defaultOpen: true,
      children: (
        <>
          <FlowRow label="Encryption" value="HLS AES-128" />
          {stream.kind === 'live' ? <FlowRow label="Rotation" value={`${stream.period_secs}s`} /> : null}
        </>
      ),
    }],
    [{
      id: 'cdn', title: 'CDN', icon: <Globe size={16} />, to: ['viewer'], defaultOpen: true,
      children: <FlowRow label="Role" value="edge cache" />,
    }],
    [{
      id: 'viewer', title: 'Viewer', icon: <MonitorPlay size={16} />, defaultOpen: true,
      children: <FlowRow label="Player" value="HLS" />,
    }],
  ];

  return <FlowDiagram columns={columns} />;
}
